<!--
 * @Author: hai.zhang
 * @LastEditors: xuxiaofei
 * @Date: 2019-11-07 19:33:07
 * @LastEditTime: 2021-09-16 10:23:49
 -->
<template>
  <div class="header" id="top">
    <div class="top">
      <div class="layout">
        <div class="header-left">
          <i class="location"></i>
          <scity optionalTabs="pc" @input="input" :data="data" ref="area" :clearable="false" :isHome="true"></scity>
        </div>
        <div class="header-right">
          <span ref="headerTopContent" v-html="headerTopContent"></span>
          <div v-show="languagePart.languageOpt.length > 1" class="language-select">
            <a class="font-color-hover-primary">
              <i class="iconfont language-icon">&#xe702;</i>
              <span>{{languagePart.usedLanguage.desc}}<i class="triangle"></i></span>
            </a>
            <ul>
              <!-- <li>当前语言：{{languagePart.usedLanguage.desc}}</li> -->
              <li v-for="item in languagePart.languageOpt" @click="changeCookie(item.code, item.desc)" :key="item.code">
                <a class="font-color-hover-primary" :class="{'font-color-primary': item.code == languagePart.usedLanguage.code}">{{item.desc}}</a>
                <i v-show="languagePart.usedLanguage.code == item.code" class="el-icon-check" :class="{'font-color-primary': item.code == languagePart.usedLanguage.code}"></i>
              </li>
            </ul>
          </div>
          <div v-show="helpShow" class="help-link">
            <router-link
             :to="{path: '/help/list', query: {buriedPoint: `${JSON.stringify({searchBuriedPoint: 'd34', questionClassification: 'd37', toViewDetails: 'd40', enterHelpCenter: 'd43'})}`}}"
            >
              <span>{{pageText.helpCenter}}</span>
            </router-link>
          </div>
          <div class="sy-im-box" v-if="isAuth">
            <syIm
              clientType = 'mall'
              :messageBoard = 'true'
              :showContentList = 'true'
              messageBoardType = 'text'
            ></syIm>
          </div>
          <div class="user-info">
            <span v-show="isAuth">
              <span  @click="logOut" class="font-color-hover-primary">
                <span class="urser-name">{{userInfo.name || userInfo.loginName}}</span>
                <i></i>
              </span>
              <span v-show="isQuit" class="quit" @click="handleLogOut">
                <el-button size="small">{{pageText.logOut}}</el-button>
              </span>
            </span>
            <span v-show="!isAuth">
              <a class="font-color-hover-primary" :href="login + '?url=' + encodeURIComponent(getUrl('/mall')) + '&isMall=' + isMall + '&isPreference=' + true">
                <span>{{pageText.pleaseLogIn}}</span>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <public-search ref="publicSearch" :supplierId="supplierId" @noSite="noSite"></public-search>
    <div class="function-user-guide" v-if="isShowChooseCity">
      <div class="top">
        <div class="layout">
          <div class="header-left">
            <i class="location"></i>
            <scity optionalTabs="pc" @input="input" :data="data" ref="areaTips" :clearable="false" :isHome="true" :placeholder="pageText.failedLocate"></scity>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import Api from './api.js'
import PublicSearch from './header/index.vue'
import Scity from '@/components/vue-area/scity.vue'
import { getUrl } from '@/utils/url.js'
import response from 'fe-coms/utils/response'
import { mapActions, mapState } from 'vuex'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'header',
  components: {
    Scity,
    PublicSearch
  },
  props: {
    supplierId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      path: this.$route.path,
      pageText,
      supplierIdMap: {
        '-1': 'lingyong_index',
        '-2': 'lijiu_index'
      },
      isGetCity: true,
      data: {
        province: {
          name: '',
          code: ''
        },
        city: {
          name: '',
          code: ''
        }
      },
      isQuit: false, // 控制“退出登录”的显示隐藏
      flag: false, // 控制“退出登录”的显示隐藏时，点body时区别点击的是不是用户信息
      exit: getUrl(Api.exit.url),
      isMall: true,
      login: `/purchaser/${window.fe.loginWay ? `?loginWay=${window.fe.loginWay}` : ''}#/member/login`,
      languagePart: {
        languageOpt: [
          // {
          //   code: 'zh-CN',
          //   desc: '简体中文'
          // },
          // {
          //   code: 'en',
          //   desc: '英语'
          // },
          // {
          //   code: 'ja',
          //   desc: '日语'
          // }
        ],
        usedLanguage: {
          code: '',
          desc: ''
        }
      },
      helpShow: false
    }
  },
  watch: {
    site: function (n, o) {
      this.data = {
        province: {
          name: n.provinceName,
          code: n.provinceCode
        },
        city: {
          name: n.cityName,
          code: n.cityCode
        }
      }
      this.isGetCity = !!(n.provinceName && n.provinceCode)
      this.$nextTick(() => {
        this.$refs.area.initSelected(n.provinceName && n.provinceCode ? this.data : null)
      })
    },
    headerTopContent: {
      handler (n) {
        if (n) {
          this.$nextTick(() => {
            this.setCurrentitem()
          })
        }
      },
      immediate: true
    },
    $route: {
      handler () {
        if (this.path === this.$route.path) {
          this.$nextTick(() => {
            this.setCurrentitem()
          })
        }
      }
    }
  },
  methods: {
    getUrl,
    ...mapActions([
      'setSite'
    ]),
    setCurrentitem () {
      if (this.$refs.headerTopContent) {
        let $lis = this.$refs.headerTopContent.querySelectorAll('.my-mall>li')
        for (let i = 0; i < $lis.length; i++) {
          let $href = $lis[i].querySelector('a').href
          let path = this.$route.path
          // 重置导航样式
          $lis[i].querySelector('a').className = 'font-color-hover-primary'
          $lis[i].className = 'font-color-hover-primary'
          if ($href.split('#')[1] === path) {
            $lis[i].querySelector('a').className = 'font-color-primary'
            $lis[i].className = 'font-color-primary current-li'
          }
        }
      }
    },
    async getHelpOpenMenu () {
      const api = Api.isOpenMenu
      let params = {appCode: 'knowledge_management'}
      let result = await response(this.$http(api.type, api.url, params))
      if (result.code === 'success' && result.content) {
        this.helpShow = true
      }
    },
    noSite () {
      this.data = null
      this.isGetCity = false
      this.$nextTick(() => {
        this.$refs.areaTips && this.$refs.areaTips.changeStatus(true)
      })
    },
    getItem (key) {
      return window.localStorage.getItem(key)
    },
    setItem (key, value) {
      window.localStorage.setItem(key, value)
    },
    // 退出登录的显示隐藏
    logOut () {
      this.isQuit = !this.isQuit
      this.flag = true
    },
    handleLogOut () {
      this.$syRouter && this.$syRouter.reset()
      window.location.href = this.exit + '&url=' + encodeURIComponent(getUrl('/mall')) + '&isMall=' + this.isMall
    },
    windowReload () {
      window.location.reload()
    },
    // 顶部城市切换
    input (data) {
      this.data = data
      let param = {
        cityCode: this.data.city.code,
        cityName: this.data.city.name,
        provinceCode: this.data.province.code,
        provinceName: this.data.province.name,
        countyCode: this.data.area ? this.data.area.code : '',
        countyName: this.data.area ? this.data.area.name : '',
        townCode: this.data.street ? this.data.street.code : '',
        townName: this.data.street ? this.data.street.name : ''
      }
      this.setSite(param).then((res) => {
        if (res.code === 'success' && res.success === true) {
          this.windowReload()
        }
      })
      window.fe.spmD('d121')
    },
    // 获取当前租户的语言列表
    async getLanguageList () {
      const api = Api.getLanguage
      let res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        this.languagePart.languageOpt = res.content
        this.syncLanguage()
      } else {
        this.$message.error(this.pageText.failedGetLanguageList)
      }
    },
    // 根据租户选择的语言来更改cookie
    changeCookie (code, desc) {
      this.$syRouter && this.$syRouter.reset()
      Cookies.set('language', code)
      location.reload()
    },
    // 根据Cookie同步当前所使用的语言
    syncLanguage () {
      let code = Cookies.get('language')
      this.languagePart.usedLanguage.code = code
      for (let item of this.languagePart.languageOpt) {
        if (item.code === this.languagePart.usedLanguage.code) {
          this.languagePart.usedLanguage.desc = item.desc
          break
        }
      }
    }
  },
  created () {
    document.addEventListener('click', (e) => {
      // 点击“退出登录”相关
      if (this.flag) {
        this.flag = false
      } else {
        this.isQuit = false
      }
      let href = e.target.getAttribute('href')
      let pathGather1 = ['/mall/#/', '/mall/#/portal', '/mall/#/pr/center', '/mall/#/order/list']
      let pathGather2 = ['/#/', '/#/portal', '/#/pr/center', '/#/order/list']
      this.$nextTick(() => {
        if (document.getElementById('language-select') && document.getElementById('language-select').contains(e.target)) {
          if (pathGather1.indexOf(href) !== -1 || pathGather2.indexOf(href) !== -1) {
            this.$router.push({
              path: e.target.hash.split('#')[1]
            })
          }
        }
      })
    })
    this.getLanguageList()
    this.getHelpOpenMenu()
    this.$nextTick(() => {
      this.setCurrentitem()
    })
  },
  computed: {
    getRouter () {
      return this.$route.name
    },
    // 使用对象展开运算符将 getter 混入 computed 对象中
    // 把 `this.cartCount` 映射为 `this.$store.getters.cartCount`
    ...mapState({
      site: state => state.area.site,
      isAuth: state => state.user.isAuth,
      userInfo: state => state.user.userInfo,
      headerTopContent: state => state.user.headerTopContent
    }),
    isShowChooseCity () {
      if (!this.isGetCity) {
        document.body.parentNode.style.overflow = 'hidden'
      } else {
        document.body.parentNode.style.overflow = 'auto'
      }
      return !this.isGetCity
    }
  }
}
</script>

<style scoped lang="scss">
  .language-select{
    height: 30px;
    padding: 0 12px;
    float: left;
    position: relative;
    ul{
      display: none;
      list-style: none;
      position: absolute;
      left: -2px;
      top: 25px;
      padding: 0 0 8px 0;
      width: 160px;
      background-color: #fff;
      z-index: 999;
      border: 1px solid #fff;
      text-shadow: 5px 5px 5px #fff;
      color: #666;
      -webkit-transition: all .3s;
      transition: all .3s;
      border-radius: 4px;
      -webkit-box-shadow: 0 2px 8px rgba(0,0,0,.15);
      box-shadow: 0 2px 8px rgba(0,0,0,.15);
      background-clip: padding-box;
    }
    & > a{
      cursor: pointer;
      color: #ededed;
      text-decoration: none;
      // span{
      //   position: relative;
      //   bottom: 1px;
      // }
    }
    .language-icon {
      font-size: larger;
      height: 15px;
      vertical-align: middle;
    }
  }
  .language-select .triangle{
    position: relative;
    top: -3px;
    left: 4px;
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid currentColor;
  }
  .language-select ul li:first-of-type {
    // color: #999;
    // line-height: 28px;
    // border-bottom: 1px solid #EEEEEE;
    // padding: 0 12px;
    padding: 8px 12px 0 12px;
  }
  // .language-select ul li:nth-child(2) {
  //   padding: 8px 12px 0 12px;
  // }
  .language-select ul li{
    padding: 0 12px;
  }
  .language-select:hover ul {
    display: block;
  }
  .language-select li i {
    margin-top: 10px;
    float: right;
  }

  .function-user-guide{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20000;
    background: rgba(0, 0, 0, 0.6)
  }
  @keyframes flash{
      from {
          opacity: 0;
      }
      to {
          opacity: 1;
      }
  }
  .header{
    .top{
      // height: 30px;
      background-color: #344159;
      height: 32px;
      font-size: 12px;
      box-sizing: border-box;
      padding: 0 24px;
      display: flex;
      line-height: 32px;
      position: relative;
      color: #ededed;
      .header-left{
        display: inline-block;
        width: 300px;
        vertical-align: middle;
        //background-color: #f6f6f6;
        height: 30px;
        margin-top: -3px;
        i.location{
          display: inline-block;
          width: 12px;
          height: 15px;
          background: url($img-url + "158433964112198772.svg");
          position: relative;
          top: 3px;
        }
      }
      .header-right{
        float: right;
        ::v-deep #mallWorkbench>li {
          border-right: none;
        }
        ::v-deep #mallWorkbench li > a {
          color: #eaebed;
        }
        ::v-deep #mallWorkbench li ul a {
          color: #666;
        }
        ::v-deep #mallWorkbench i {
          border-top-color: #ededed;
        }
        ::v-deep .user-info a {
          color: #eaebed;
        }
        .user-info{
          display: inline-block;
          cursor: pointer;
          position: relative;
          color: #ededed;
          padding-left: 10px;
          .dividing-line{
            font-size: 14px;
            color: #d9d9d9;
            padding-left: 3px;
            padding-right: 15px;
          }
          i{
            position: relative;
            top: -3px;
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid currentColor;
          }
          .quit{
            z-index: 99;
            position: absolute;
            top: 26px;
            right: 0;
            button{
              background-color: #fff;
              border: 1px solid #fff;
              text-shadow: 5px 5px 5px #fff;
              // color: rgba(0,0,0,.65);
              -webkit-transition: all .3s;
              transition: all .3s;
              border-radius: 4px;
              -webkit-box-shadow: 0 2px 8px rgba(0,0,0,.15);
              box-shadow: 0 2px 8px rgba(0,0,0,.15);
              background-clip: padding-box;
            }
          }
        }
      }
    }
  }
  .sy-im-box {
    display: inline-block;
    cursor: pointer;
    position: relative;
    color: #eaebed;
    ::v-deep .sy-im {
      padding-left: 10px;
      em {
        padding-right: 0 !important;
        vertical-align: inherit !important;
      }
    }
  }
  .help-link {
    height: 30px;
    display: inline-block;
    cursor: pointer;
    position: relative;
    color: #666;
    padding-left: 10px;
    i {
      font-size: 14px;
      margin-right: 2px;
    }
    a {
      color: #eaebed;
    }
  }
</style>
<style lang="scss">
  html {
    width: 100%;
    height: 100%;
    //background-color: #F6F6F6;
  }
  body,
  #app{
    position: relative;
    box-sizing: border-box;
    //min-height: 100vh;
    height: 100%;
    min-width: 1200px;
  }
  .layout{
    position: relative;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
  }
  button.el-button{
    border-radius: 4px;
  }
  .header .header-left .mod-Scity{
    top: -30px;
    left: 13px;
    &.active{
      height: 30px;
      z-index: 100;
    }
    .area-input{
      color: #ededed;
      border: none;
      width: auto;
      display: inline-block;
      .selected{
        cursor: pointer;
        padding: 0 6px;
        display: inline-block;
        color: #ededed;
      }
      .placeholder{
        font-size: 12px;
        padding: 0 10px;
        color: #E61111 !important;
      }
    }
    .area-content{
      color: #999;
      left: -13px;
      .area-list{
        height: 264px;
        line-height: 28px;
        .area-item{
          display: inline-block;
          width: 25%;
          padding: 0px 16px 0px 5px;
          box-sizing: border-box;
          margin-right: 0px;
          margin-left: 0px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }
    }
  }
</style>
